import React from "react";

const EmptyData = ({ message }) => {
  return <div>{message}</div>;
};

export default EmptyData;
